import { Modal, Skeleton, Typography } from "antd";
import { MazakaCheckbox } from "apps/Common/MazakaCheckbox";
import { Link } from "react-router-dom";
import { useGetContractByType,  } from "../../ServerSideStates";
import { useState } from "react";
import ContractPaymentDescription from "./ContractPaymentDescription";

const ContractCheckbox = () => {
    const contract =  useGetContractByType("1003")
    const {Text} = Typography
    const data = contract?.data?.data||null
    const[isShowAgreementModal,setIsShowAgreementModal] = useState(false)
    return ( <>
     <Skeleton loading={contract.isLoading ||contract.isFetching} >
      {
        data&&
               <MazakaCheckbox
               name={data?.name||""}
                        rules={[{ required: true }]}
                        
                        text={
                          <Text className="!text-[#606060]">
                            <Text
                             className="!text-[#1878ff] !cursor-pointer"
                            onClick={()=>{
                              setIsShowAgreementModal(true)
                            }}
                            >
                              {data?.title ||""}
                            </Text>{" "}
                            kabul ediyorum.
                          </Text>
                        }/>
      }

                </Skeleton>
                <Modal
        open={isShowAgreementModal}
        onCancel={() => {
          setIsShowAgreementModal(false);
        }}
        footer={false}
        width={"80%"}
      >
        <ContractPaymentDescription containerClassNames={"!px-4"} />
      </Modal>
    
    </> );
}
 
export default ContractCheckbox;